import _get from 'lodash.get';

const APPLE_PAY_CONTAINER_ID = 'applepay-container';
function extractApplePayToken(state) {
    const token = _get(state, 'data.paymentMethod.applePayToken', null);
    return typeof token === 'string' ? token : null;
}

export { APPLE_PAY_CONTAINER_ID, extractApplePayToken };
//# sourceMappingURL=AdyenApplePayButton.static.js.map
